import styled from '@emotion/styled'

export const ChangeStatusButtonWrapper = styled.div`
  flex-shrink: 0;
`
